import { createContext } from "react";

export const IsDarkContext = createContext(null);